import React, {useState} from "react";
import Grid from "@mui/material/Grid";
import {useGlobalContext} from "../store/appContext";
import axios from "axios";
import { Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material'
import Button from '@mui/material/Button'
import {BookedDay} from '../store/types'
import DeleteForever from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import dayjs from "dayjs";
import { Link } from 'wouter'
import { getButtonProps } from '../methods/shared'
import { useHashLocation } from "wouter/use-hash-location";

axios.defaults.withCredentials = true

export default function OwnerBookingsList({
  onDeleteClick,
  onEditClick,
}: {
  onDeleteClick: (booking: BookedDay) => void
  onEditClick: (booking: BookedDay, dateStart: string, dateEnd: string) => void
}) {
  const {calendarBookings, isMobile, usedTheme, setSelectedBooking} = useGlobalContext()
  const [location, setLocation] = useHashLocation();
  const [editingBooking, setEditingBooking] = useState<BookedDay | null>(null);
  const [editStart, setEditStart] = useState<moment.Moment | null>(null);
  const [editEnd, setEditEnd] = useState<moment.Moment | null>(null);

    return (
      <Grid
        container
        className="bookings-list items-center justify-center text-center"
        style={{
          marginBottom: '300px'
      }}>
        <div className={'pt-2 pb-5'}>
          <Link href="/upcoming">
            <Button
              {...getButtonProps(location, '/owner_reservations/upcoming')}
            >
              Upcoming
            </Button>
          </Link>
          <Link href="/history">
            <Button
              {...getButtonProps(location, '/owner_reservations/history')}
            >
              History
            </Button>
          </Link>
        </div>
        {
          calendarBookings
            .filter(booking => booking.ownerReservation)
            .filter(booking => {
              const typeName = location.split('/').pop()
              return typeName === 'upcoming'
                ? dayjs(booking.endDay).isAfter(dayjs(), 'day')
                : !dayjs(booking.endDay).isAfter(dayjs(), 'day')
            })
            .map((booking, index) => {
              const typeName = location.split('/').pop()
              const canDelete = !!booking._id
              // TODO: re-enable once overlap validation is added on save
              const canEdit = false && typeName === 'upcoming' && !!booking._id
              return (
                <Grid
                  key={`${booking._id} ${index}`}
                  container
                  justifyContent="center"
                  className="py-1"
                >
                  <Grid item xs={12}
                        className="py-0 my-0 font-bold"
                  >
                    <Chip
                      label={booking.startDay?.format('DD.MM.YYYY') + ' - ' + booking.endDay?.format('DD.MM.YYYY') + ' ' + booking.ownerNotes}
                      className="mr-2 chip-dates"
                      variant="outlined"
                      onClick={() => {
                        console.log('booking', booking)
                        setSelectedBooking(booking ? booking as BookedDay : null)
                      }}
                    />
                    <Chip
                      label={booking.nights + ' nights'}
                      style={{
                        background: usedTheme?.palette.secondary.light,
                      }}
                      className="mx-2 chip-days"
                      variant="outlined"
                      onClick={() => {
                        setSelectedBooking(booking ? booking as BookedDay : null)
                      }}
                    />
                    {canEdit && (
                      <IconButton onClick={() => {
                        setEditingBooking(booking as BookedDay)
                        setEditStart(moment(booking.startDay.toDate()))
                        setEditEnd(moment(booking.endDay.toDate()))
                      }}>
                        <EditIcon style={{ fontSize: '1.6rem' }} />
                      </IconButton>
                    )}
                    <IconButton
                      disabled={!canDelete}
                      onClick={() => {
                        if (canDelete && window.confirm('Delete?')) {
                          onDeleteClick(booking as BookedDay)
                        }
                      }}
                    >
                      <DeleteForever style={{ fontSize: '1.6rem', color: canDelete ? 'red' : 'grey' }} />
                    </IconButton>
                  </Grid>
                </Grid>

              )
            })
        }

        <Dialog open={!!editingBooking} onClose={() => setEditingBooking(null)}>
          <DialogTitle>Edit reservation dates</DialogTitle>
          <DialogContent style={{ paddingTop: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <DatePicker
              label="Start date"
              value={editStart}
              onChange={(v) => setEditStart(v)}
              format="DD.MM.YYYY"
            />
            <DatePicker
              label="End date"
              value={editEnd}
              onChange={(v) => setEditEnd(v)}
              format="DD.MM.YYYY"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditingBooking(null)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                if (editingBooking && editStart && editEnd) {
                  onEditClick(
                    editingBooking,
                    editStart.format('YYYY-MM-DD'),
                    editEnd.format('YYYY-MM-DD'),
                  )
                  setEditingBooking(null)
                }
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

      </Grid>

    );
};
